import apiClient from './api';

export const contactService = {
  getContact: async () => {
    const response = await apiClient.get('/contact');
    return response.data?.data || response.data;
  },
  getAdminContact: async () => {
    const response = await apiClient.get('/contact/admin');
    return response.data?.data || response.data;
  },
  updateContact: async (payload) => {
    const response = await apiClient.put('/contact/admin', payload);
    return response.data?.data || response.data;
  },
  submitInquiry: async (payload) => {
    const response = await apiClient.post('/contact/inquiry', payload);
    return response.data;
  },
};

export default contactService;
